import { TIMING_SEARCH_INPUT_OPTIONS } from '~services/constant/statistics';
import HelperOptions from '~component/helper/helper-options';

// 搜索打卡记录的主输入框，对应的字段类型
export default {
  functional: true,
  render(createElement, context) {
    const { data } = context;

    return (
      <HelperOptions
        { ...data }
        options={ TIMING_SEARCH_INPUT_OPTIONS }
      />
    );
  },
};
